const hasProperty = (target: Record<string, unknown>, property: string) => Object.prototype
  .hasOwnProperty
  .call(target, property);

export default hasProperty;
